/* Utilitários de data do Relatório de Consumo.
   Máscara/conversões copiadas do padrão do Dashboard (dd/MM/yyyy ↔ ISO),
   + helpers do ciclo de faturamento 21→20 e navegação por setas. */

// dd/MM/yyyy -> yyyy-MM-dd
export function brDateToISO(brDate) {
  if (!brDate || brDate.length !== 10) return "";
  const [day, month, year] = brDate.split("/");
  return `${year}-${month}-${day}`;
}

// yyyy-MM-dd -> dd/MM/yyyy
export function isoDateToBR(isoDate) {
  if (!isoDate || isoDate.length !== 10) return "";
  const [year, month, day] = isoDate.split("-");
  return `${day}/${month}/${year}`;
}

// Máscara progressiva dd/MM/yyyy
export function applyDateMask(value) {
  const numbers = value.replace(/\D/g, "");
  if (numbers.length <= 2) return numbers;
  if (numbers.length <= 4) return `${numbers.slice(0, 2)}/${numbers.slice(2)}`;
  return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}/${numbers.slice(4, 8)}`;
}

function pad(n) {
  return String(n).padStart(2, "0");
}

export function toISO(date) {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function fromISO(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  return new Date(y, m - 1, d);
}

/* Ciclo de faturamento: 21 do mês anterior → 20 do mês corrente; a partir do
   dia 21, vira para 21 do mês corrente → 20 do próximo. (Mesma regra do
   backend — usada só como fallback antes do filter_options responder.) */
export function defaultCycle(today = new Date()) {
  const y = today.getFullYear();
  const m = today.getMonth(); // 0-based
  if (today.getDate() >= 21) {
    const start = new Date(y, m, 21);
    const end = new Date(y, m + 1, 20);
    return { start: toISO(start), end: toISO(end) };
  }
  const start = new Date(y, m - 1, 21);
  const end = new Date(y, m, 20);
  return { start: toISO(start), end: toISO(end) };
}

/* Soma meses mantendo o dia (clampa no fim do mês quando necessário). */
export function shiftMonthsISO(iso, delta) {
  const d = fromISO(iso);
  const day = d.getDate();
  const target = new Date(d.getFullYear(), d.getMonth() + delta, 1);
  const lastDay = new Date(
    target.getFullYear(),
    target.getMonth() + 1,
    0
  ).getDate();
  target.setDate(Math.min(day, lastDay));
  return toISO(target);
}

export function shiftDaysISO(iso, delta) {
  const d = fromISO(iso);
  d.setDate(d.getDate() + delta);
  return toISO(d);
}

/* Primeiro/último dia de um mês (0-based month). */
export function monthRangeISO(year, month) {
  const start = new Date(year, month, 1);
  const end = new Date(year, month + 1, 0);
  return { start: toISO(start), end: toISO(end) };
}

export function isWeekendISO(iso) {
  const dow = fromISO(iso).getDay();
  return dow === 0 || dow === 6;
}

/* Rótulo curto do bucket para o eixo X (rotacionado 90° na tela). */
export function bucketTick(bucket, granularity) {
  if (granularity === "hour") return `${bucket}h`;
  return `${bucket.slice(8, 10)}/${bucket.slice(5, 7)}`; // dd/mm
}

/* Rótulo completo do bucket para tooltip/tabela. */
export function bucketLabel(bucket, granularity, locale = "pt-BR") {
  if (granularity === "hour") return `${bucket}:00`;
  const d = fromISO(bucket);
  const dow = d.toLocaleDateString(locale, { weekday: "short" });
  return `${dow} ${pad(d.getDate())}/${pad(d.getMonth() + 1)}`;
}
